var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3889 7.66667H1.61114M19.3889 7.66667V17.4444C19.3889 18.6889 19.3889 19.3111 19.1467 19.7867C18.9336 20.2048 18.5937 20.5447 18.1756 20.7578C17.7011 21 17.0789 21 15.8367 21H5.16225C3.92003 21 3.29891 21 2.82447 20.7578C2.40669 20.5444 2.06669 20.2044 1.85336 19.7867C1.61114 19.3111 1.61114 18.6911 1.61114 17.4489V7.66667M19.3889 7.66667V6.77778C19.3889 5.53333 19.3889 4.91111 19.1467 4.43556C18.9334 4.01667 18.5945 3.67778 18.1756 3.46444C17.7 3.22222 17.0778 3.22222 15.8334 3.22222H14.9445M1.61114 7.66667V6.77444C1.61114 5.53222 1.61114 4.91 1.85336 4.43556C2.06641 4.01744 2.40635 3.67749 2.82447 3.46444C3.30003 3.22222 3.92225 3.22222 5.16669 3.22222H6.05558M14.9445 3.22222H6.05558M14.9445 3.22222V1M6.05558 3.22222V1M8.2778 16.5556L10.5 14.3333M10.5 14.3333L12.7222 12.1111M10.5 14.3333L8.2778 12.1111M10.5 14.3333L12.7222 16.5556",
    stroke: "url(#paint0_linear_3366_11763)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3366_11763",
    x1: 19.3889,
    y1: 1,
    x2: -0.473153,
    y2: 18.6552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSession);
export default __webpack_public_path__ + "static/media/closeSession.c220244577c93011f2c5c4bf2af3bd97.svg";
export { ForwardRef as ReactComponent };